import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";

const useStyles = makeStyles((theme) => ({
  toTop: {
    zIndex: 2,
    position: "fixed",
    bottom: "4.5vh",
    color: "#000000",
    size: "medium",
    "&:hover, &.Mui-focusVisible": {
      transition: "0.3s",
      color: "#ffffff",
      backgroundColor: "#020d41",
    },
    [theme.breakpoints.up("xs")]: {
      right: "5px",
      backgroundColor: "#475497",
      color: "#ffffff",
    },
    [theme.breakpoints.up("lg")]: {
      right: "10px",
    },
  },
}));

const Scroll = ({ showBelow }) => {
  const classes = useStyles();

  const [show, setShow] = useState(showBelow ? false : true);

  const handleScroll = () => {
    if (window.pageYOffset > showBelow) {
      if (!show) setShow(true);
    } else {
      if (show) setShow(false);
    }
  };

  const handleClick = () => {
    window[`scrollTo`]({ top: 0, behavior: `smooth` });
  };

  useEffect(() => {
    if (showBelow) {
      window.addEventListener(`scroll`, handleScroll);
      return () => window.removeEventListener(`scroll`, handleScroll);
    }
  });

  return (
    <div className="projectUp">
      {show && (
        <IconButton onClick={handleClick} className={classes.toTop} aria-label="to top">
          <ExpandLessIcon />
        </IconButton>
      )}
    </div>
  );
};
export default Scroll;


